import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {Observable} from 'rxjs/Observable';


export enum GLOBAL_NOTIFICATION_TYPE {
	SUCCESS,
	WARNING,
	ERROR
}
export interface GlobalNotification {
	id: number;
	type: GLOBAL_NOTIFICATION_TYPE;
	message: string;
	hideIn: number;
}

@Injectable()
export class GlobalNotificationsService {

	private _notification: Subject<GlobalNotification> = new Subject<GlobalNotification>();

	constructor() {

	}

	public sendNotification(type: GLOBAL_NOTIFICATION_TYPE, message: string, hideIn?: number): void {
		this._notification.next({
			id: Date.now() + Math.floor((Math.random() * 100) + 1),
			type: type,
			message: message,
			hideIn: hideIn
		});
	}

	public onNewNotification(): Observable<GlobalNotification> {
		return this._notification.asObservable();
	}

}



// WEBPACK FOOTER //
// ./src/app/core/components/global-notifications/global-notifications.service.ts